module.exports = __webpack_public_path__ + "img/image-portrait.4647d244.svg";